<button mat-icon-button id="modal-close-icon" class="no-hover-effect" (click)="cancel()">
  <mat-icon aria-label="Close">close</mat-icon>
</button>

<mat-card-title dense>
  Request New User
</mat-card-title>

<div [formGroup]="userDataForm">
  <mat-card-content>

    <app-user-search-ad [invalidEmailMessage]="invalidEmailMessage"
                        (selectedUserOutput)="getSelectedUser($event)"
                        (formStatusOutput)="getChildFormStatus($event)">
    </app-user-search-ad>

    <mat-form-field>
      <input matInput placeholder="First Name" formControlName="firstName"
             required=true maxlength="30" />
    </mat-form-field>

    <mat-form-field>
      <input matInput placeholder="Last Name" formControlName="lastName"
             required=true maxlength="30" />
    </mat-form-field>

    <app-role-select-clone></app-role-select-clone>

  </mat-card-content>
</div>

<button mat-raised-button class="ok-button" color="accent" (click)="sendNewUserRequestEmail()"
        [disabled]="!userDataForm.valid || !isUserSearchAdFormValid">OK</button>
<button mat-button color="primary" class="ok-button" (click)="cancel()">CANCEL</button>
